import { render, staticRenderFns } from "./IPHistory.vue?vue&type=template&id=5b8386c6"
import script from "./IPHistory.vue?vue&type=script&lang=js"
export * from "./IPHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports